import { useLocation, useNavigate } from "react-router-dom";
import Header from "components/header/HeaderAuthDefault";
import httpService from "services/http-service";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import InputField from "components/fields/InputField";
import { getLocalStorageKey } from "utils/utils";
import logo from "assets/img/logo/logo.png";


export default function SignIn( {
  isProfile = false
}) {
  
  const navigate = useNavigate();
    const eventId = getLocalStorageKey("eventId");
  
  const location = useLocation();
  const [isRegular, setIsRegular] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [eventDetail, setEventDetail] = useState();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    setTimeout(() => {
    populateEventData();
      
    }, 1000);

    const email = urlParams.get('email');
    if (email) {
      localStorage.setItem('userEmail', email);
      setPhoneNumber(email);

      handleLogin(email);

    }
  }, [location]);

  
  const handlePhoneNumberChange = (event) => {
    const inputValue = event.target.value;
    setPhoneNumber(inputValue);

    // Email syntax validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsValid(emailPattern.test(inputValue));
  };

 

  

  const handleRouteClick = (page) => {
    navigate(page); // Navigate to specific page
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };
  

  const handleLogin = async (email = '') => {
    if (phoneNumber || email) {
      setLoading(true);
      localStorage.setItem('userEmail', JSON.stringify(phoneNumber  || email))
      const endpoint = `Verification/EmailVerificationCode/${phoneNumber  || email}`
      const response = await httpService("POST", endpoint, {});
      if (!response) {
        setLoading(false);
        toast.error(response.message || 'Error Logging in');
      } else {

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'user_login',
          userId: 0, // optional
          method: 'standard', // or 'google', 'facebook', etc.
        });

        if (response) {
          setLoading(false);
          localStorage.setItem("userDetails", JSON.stringify(response));

          const status = response.accountSetupStatus;
          const isSetupDone = status === "Completed" || status === "Setup Completed";

          if (isSetupDone) {
            const token = response.token;
            if (token) {
              localStorage.setItem("token", token);
              localStorage.setItem('isVerifiedUser', true);
            }
            toast.success("You are logged in Successfully");
            if (isProfile) {

            } else {
              navigate("/auth/home", { replace: true });
            }
          } else {
            toast.success("Spots SMS code has been sent");
            if (isProfile) {

            } else {
              navigate("/auth/verify", {
                state: {
                  isRegular: isRegular,
                },
              });
            }
          }
        }
      }
    }
  };


      const populateEventData = async () => {
      setLoading(true);
  
      try {
  
  
        if (eventId) {
          const eventResponse = await httpService("GET", `/Event/${eventId}`);
          if (eventResponse.Error === "HttpException") {
            toast.error(eventResponse.Message);
            setLoading(false);
            return;
          } else {
            setEventDetail(eventResponse)
          }
        }

      } catch (error) {
        toast.error('An error occurred while fetching data');
        console.error('Fetch data error:', error);
      } finally {
        setLoading(false);
      }
    };


 

 return (
  <div>
   <Loading loading={loading} loaderColor="#252424" />




<div 
  className="absolute top-0 left-0 w-full h-64 flex justify-center items-end pb-6 bg-cover bg-center bg-no-repeat"
  style={{ backgroundImage: "url('/semi-pvt-event.jpg')" }}
>
  {/* Optional dark overlay */}
  <div className="absolute inset-0 bg-black/30" />
  
  <img
    src={(eventDetail?.hosts?.length > 0 && eventDetail?.hosts[0]?.photoUrl) || "/useravatar.png"}
    alt="Host Avatar"
    className="relative h-24 w-24 rounded-full object-cover border-4 border-white shadow-md translate-y-10 z-10"
  />
</div>

    {/* Content below the header */}
    <div className="w-full max-w-sm text-center px-4 mt-64">

      {/* Host name and subtitle */}
      <h2 className="text-lg font-semibold text-brand-500">{(eventDetail?.hosts?.length > 0 && eventDetail?.hosts[0]?.hostName )|| 'Host'}</h2>
      <p className="text-sm text-gray-500 mb-4">Your {(eventDetail?.hosts?.length > 0 && eventDetail?.hosts[0]?.name )|| 'Host'}</p>

      {/* Event Name */}
<h3 className="text-xl font-semibold text-brand-500">{eventDetail?.name}</h3>
     <p className="text-xs text-gray-600 mt-1 mb-6">
  Get access to event photos and contacts
</p>


      {/* Email input */}
      <input
        type="email"
        placeholder="Your email"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        className={`w-full h-12 rounded-md border px-4 text-sm focus:outline-none ${
          isValid ? "border-gray-300" : "border-red-500"
        }`}
      />
      {!isValid && (
        <p className="text-red-500 text-xs mt-1 text-left">
          Please enter a valid email address
        </p>
      )}

      {/* Continue button */}
     <button
  onClick={handleLogin}
  className={`mt-6 w-full rounded-md py-3 text-sm font-medium text-white ${
    phoneNumber.length > 2
      ? "bg-brand-500 hover:bg-brand-600"
      : "bg-gray-500 cursor-not-allowed opacity-50"
  }`}
>
  Continue
</button>


      {/* Step info */}
      {/* <p className="text-sm font-semibold text-brand-500 mt-6 mb-10">Step 1 of 2</p> */}

      {/* Captcha-like section */}
  {/* Footer — pinned to bottom */}
<div className="flex flex-col items-center pb-6 pt-3">
  <p
    className="text-2xl font-semibold text-gray-800"
    style={{ letterSpacing: "0.35em" }}
  >
    SXENE
  </p>
  <p
    className="text-[10px] text-gray-400 font-medium mt-2"
    style={{ letterSpacing: "0.25em" }}
  >
    PEOPLE. EVENTS. CONNECTIONS.
  </p>
</div>

    </div>
  </div>
);

}
